export const ROUTE_PATHS = Object.freeze({
  HOME: '/',
  COMPONENTS: '/componentes',
  LOGIN: '/login',
  CHANGE_PASSWORD: '/cambiar-contrasena',
  VOTER_PROFILE: '/mi-perfil',
  DASHBOARD: '/dashboard',
  ELECTORAL_STRUCTURE: '/estructura-electoral',
  VOTERS: '/votantes',
  VOTER_DETAIL: '/votantes/:id',
  DUPLICATES: '/duplicados',
  CALL_SHEETS: '/control-planillas',
  CALL_SHEET_DETAIL: '/control-planillas/:id',
  DRIVERS: '/conductores',
  VEHICLE_DETAIL: '/moviles/:id',
  USERS: '/usuarios',
  REPORTS: '/reportes',
  FINANCE: '/financiero',
  ELECTION_DAY: '/dia-d',
  ACCESS_DENIED: '/acceso-denegado',
  NOT_FOUND: '*',
});
